import React, { useState } from "react";
import { DateSchedulingDropDown } from "@public/ui-toolkit";
import moment from "moment";

const WeekTab = ({
  schedule,
  ariaLabelLedBy,
  id,
  day,
  selectedTab,
  updatedSchedule,
  setUpdatedSchedule,
  role,
  loading,
}) => {
  const [dayData, setDayData] = useState({
    fromHour: "",
    fromMin: "",
    toHour: "",
    toMin: "",
  });

  const onUpdate = (data, type, timeType) => {
    const updatedScheduleDay = updatedSchedule.filter((t) => t.day === day);
    if (typeof updatedScheduleDay[0] !== "undefined") {
      const fromTime =
        type === "hour"
          ? moment(updatedScheduleDay[0].from)
              .set("hours", data)
              .format("YYYY-MM-DDTHH:mm:ss")
          : moment(updatedScheduleDay[0].from)
              .set("minute", data)
              .format("YYYY-MM-DDTHH:mm:ss");

      const toTime =
        type === "hour"
          ? moment(updatedScheduleDay[0].to)
              .set("hours", data)
              .format("YYYY-MM-DDTHH:mm:ss")
          : moment(updatedScheduleDay[0].to)
              .set("minute", data)
              .format("YYYY-MM-DDTHH:mm:ss");

      let index = updatedSchedule.findIndex((t) => t.day === day);
      var updatedScheduleData = [...updatedSchedule];
      updatedScheduleData[index] = {
        ...updatedScheduleDay[0],
        from: timeType === "from" ? fromTime : updatedScheduleDay[0].from,
        to: timeType === "to" ? toTime : updatedScheduleDay[0].to,
      };
      setUpdatedSchedule(updatedScheduleData);
    } else {
      const fromTime =
        type === "hour"
          ? moment(schedule[day].from)
              .set("hours", data)
              .format("YYYY-MM-DDTHH:mm:ss")
          : moment(schedule[day].from)
              .set("minute", data)
              .format("YYYY-MM-DDTHH:mm:ss");

      const toTime =
        type === "hour"
          ? moment(schedule[day].to)
              .set("hours", data)
              .format("YYYY-MM-DDTHH:mm:ss")
          : moment(schedule[day].to)
              .set("minute", data)
              .format("YYYY-MM-DDTHH:mm:ss");

      const updatedDailySchedule = {
        id: schedule[day].id,
        day: day,
        from: timeType === "from" ? fromTime : schedule[day].from,
        to: timeType === "to" ? toTime : schedule[day].to,
      };
      const updatedScheduleData = [...updatedSchedule, updatedDailySchedule];
      setUpdatedSchedule(updatedScheduleData);
    }
  };

  return (
    <div
      className={
        id === selectedTab.toLowerCase()
          ? "tab-pane fade show active"
          : "d-none"
      }
      id={id}
      role={role}
      aria-labelledby={ariaLabelLedBy}
    >
      <div className="row gy-3 mt-4">
        <div className="col-md-4">
          <h6>From</h6>
          <div className="row gy-3 gx-2">
            <div className="col-md-6">
              <label Style="font-size: 10px">hour</label>
              <DateSchedulingDropDown
                type="!primary"
                dropDownData={schedule}
                format="HH"
                day={day}
                setData={(data) => {
                  setDayData({ ...dayData, fromHour: data });
                  onUpdate(data, "hour", "from");
                }}
                timeSelection="hour"
                toOrFrom="from"
              />
            </div>
            <div className="col-md-6">
              <label Style="font-size: 10px">min</label>
              <DateSchedulingDropDown
                type="!primary"
                dropDownData={schedule}
                format="mm"
                day={day}
                setData={(data) => {
                  setDayData({ ...dayData, fromMin: data });
                  onUpdate(data, "min", "from");
                }}
                timeSelection="min"
                toOrFrom="from"
              />
            </div>
          </div>
        </div>
        <div className="col-md-4">
          <h6>To</h6>
          <div className="row gy-3 gx-2">
            <div className="col-md-6">
              <label Style="font-size: 10px">hour</label>
              <DateSchedulingDropDown
                type="!primary"
                dropDownData={schedule}
                format="HH"
                day={day}
                setData={(data) => {
                  setDayData({ ...dayData, toHour: data });
                  onUpdate(data, "hour", "to");
                }}
                timeSelection="hour"
                toOrFrom="to"
              />
            </div>
            <div className="col-md-6">
              <label Style="font-size: 10px">min</label>
              <DateSchedulingDropDown
                type="!primary"
                dropDownData={schedule}
                format="mm"
                day={day}
                setData={(data) => {
                  setDayData({ ...dayData, toMin: data });
                  onUpdate(data, "min", "to");
                }}
                timeSelection="min"
                toOrFrom="to"
              />
            </div>
          </div>
        </div>
        <div
          className="
        col-md-4
        text-center
        d-flex
        align-items-end
        justify-content-center
      "
        >
          {schedule
            ?.filter((d) => d.day === day)
            .map((date, index) => {
              return (
                <p className="mb-2" key={index}>
                  {moment(date.from).format("hh : mm a")} -
                  {moment(date.to).format("hh : mm a")}
                </p>
              );
            })}
        </div>
      </div>
    </div>
  );
};

export default WeekTab;
